import { SIA_GENERATING_PERSONAL_LINES_URL_PARAM } from '@/utils/constants/sia';

export const setPersonalLinesModalOpen = (): void => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set(SIA_GENERATING_PERSONAL_LINES_URL_PARAM, 'true');
  const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
  window.history.replaceState({}, '', newUrl);
};

export const setPersonalLinesModalClosed = (): void => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete(SIA_GENERATING_PERSONAL_LINES_URL_PARAM);
  const newUrl = `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;
  window.history.replaceState({}, '', newUrl);
};

export const isPersonalLinesModalOpen = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(SIA_GENERATING_PERSONAL_LINES_URL_PARAM) === 'true';
};

export const usePersonalLinesModalState = () => {
  return {
    isOpen: isPersonalLinesModalOpen(),
    setOpen: setPersonalLinesModalOpen,
    setClosed: setPersonalLinesModalClosed,
  };
};
